import React, { PropsWithChildren, useContext } from 'react'
import { makeStyles } from '@material-ui/core'
import { Typography } from 'foundations-library/components'
import { ScreenSizeContext } from 'providers'
const jss = () => ({
    pageTitleForSmallScreens: {
        display: ({ screenSize }) => screenSize.mobile || screenSize.tablet ? 'block' : 'none',
        textAlign: 'center',
        marginTop: '15px',
        marginBottom: '20px'
    }
})

interface PropsInterface {
    'data-testid'?: string;
}

const useStyles = makeStyles(jss)

/**
 *
 */
const PageTitleForSmallScreens = ({
    children,
    'data-testid': dataTestId = 'page-title-small-screens'
}: PropsWithChildren<PropsInterface>): JSX.Element => {
    const screenSize = useContext(ScreenSizeContext)

    const styles = useStyles({
        screenSize
    })
    return <Typography
        variant='subtitle1'
        color='neutral-900'
        tag='div'
        className={styles.pageTitleForSmallScreens}
        data-testid={dataTestId}
    >{ children }</Typography>
}

export default PageTitleForSmallScreens
